const WebFont = require('webfontloader');

WebFont.load({
  google: {
    families: [
        'Open+Sans:400,700',
        'Neuton:400',
    ],
  },
});



// WEBPACK FOOTER //
// ./scripts/google-fonts.js